import { defineComponent as _defineComponent } from 'vue';
import { createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-7684589c"), n = n(), _popScopeId(), n);
const _hoisted_1 = { class: "sms-campaigns-create" };
import { onMounted, onUnmounted } from 'vue';
import { useStore } from 'vuex';
import { mixpanelSmsCampaign } from '@/utilities/mixpanel/smsCampaigns';
import SmsCampaignsHeaderCreate from '@/features/SMSCampaigns/components/create/SMSCampaignsHeaderCreate.vue';
import SmsCampaignsDetails from '@/features/SMSCampaigns/components/create/SMSCampaignsDetails.vue';
import SmsCampaignsMessages from '@/features/SMSCampaigns/components/create/SMSCampaignsMessages.vue';
import SmsCampaignsPeriod from '@/features/SMSCampaigns/components/create/SMSCampaignsPeriod.vue';
import SmsCampaignsFooter from '@/features/SMSCampaigns/components/create/SMSCampaignsFooter.vue';
export default /*#__PURE__*/ _defineComponent({
    __name: 'SMSCampaignsCreate',
    setup(__props) {
        const store = useStore();
        onMounted(() => {
            mixpanelSmsCampaign.createSmsPageViewed();
        });
        onUnmounted(() => {
            store.commit('smsCampaigns/RESET');
        });
        return (_ctx, _cache) => {
            const _component_base_card_v2 = _resolveComponent("base-card-v2");
            return (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _createVNode(_component_base_card_v2, null, {
                    default: _withCtx(() => [
                        _createVNode(SmsCampaignsHeaderCreate),
                        _createVNode(SmsCampaignsDetails),
                        _createVNode(SmsCampaignsMessages),
                        _createVNode(SmsCampaignsPeriod),
                        _createVNode(SmsCampaignsFooter)
                    ]),
                    _: 1
                })
            ]));
        };
    }
});
